// removed by extract-text-webpack-plugin
module.exports = {"formBox":"_3C4prx3KMRqfenDBNso27O","removeIcon":"_2R26yrlmzNPPx8F4HOcI2H","formName":"mXz3fWUjyqynat-33B2T1","inputBox":"_3NlYStxXFM5vQN0yF1Dtmo","option":"_6lkqK8_xj4J-X_s7JJuts","addIcon":"_2yem7nq47W71_BaKL74U7t","deleteIcon":"zk88M-ZdK_9O6dR8Jj2Fz","indexField":"_3d-q7gdJ2cylN9KV_nwTz","setIndexButton":"_1SrCZByzgZJjAFtndO-Itg","indexNotSet":"_3mjZ8x5OVy0eZaZmOqaMmL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddTaskModal/components/Form/style.css
// module id = 136
// module chunks = 0